/**
 * Shared FAQ question strings so TipTap-free marketing pages and the pricing
 * resolver stay in lockstep (PBI #1193).
 */
export const FaqQuestions = {
  IsReallyFree: 'Is it really free?',
  CanIImportContacts: 'Can I import contacts from Google, Apple, or a spreadsheet?',
  FreeAppBirthday: 'Is there a free app to schedule birthday greetings?',
  WhoCanOrder:
    'Do I need a Personal subscription to order flowers or mailed cards?',
  WhatIsMemberPricing: 'What is member pricing?',
  SubscriptionCoversFlowers: 'Does my subscription cover the cost of flowers?',
  SubscriptionCoversMailedCards: 'Does my subscription cover the cost of mailed cards?',
} as const;
